module.exports = __webpack_public_path__ + "img/10026.2e421b8a.jpg";